import { Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../core/animations';

import { SideNavService } from '../../../../sidenav.service';

@Component({
    selector: 'pro-user-details',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
    animations: fuseAnimations
})

export class ProUserDetailComponent {

    selectedIndex = 0;

    selected: any;
    userId: string;
    userName: string;

    onProUserInfoTabSelectedSubscription: Subscription;

    constructor(public sideNavService: SideNavService) {

    }

    ngOnInit() {

        this.onProUserInfoTabSelectedSubscription =
            this.sideNavService.onProUserInfoTabSelected.subscribe(selected => {
                this.userName = selected.firstName;
            });
    }

    ngOnDestroy() {
        this.onProUserInfoTabSelectedSubscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/detail.component.ts